import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';
import autobind from 'autobind-decorator';

// import EditImage from 'common/components/edit-image';
import FieldFactory from 'common/components/field-factory';
import SongSelector from 'common/components/song-selector';

import EditImage from 'client/shared/components/edit-image/edit-image';

@inject('playlistStore', 'songsStore', 'formStore')
@observer
class PlaylistModal extends Component {
	constructor (props) {
		super(props);

		this.state = {
			modalIsOpen: false
		};
	}

	render () {
		const {
			playlistStore,
			buttonLabel = '',
			buttonClassName = 'add-button button',
			icon = 'pencil'
		} = this.props;

		return (
			<div>
				<ReactModal
					className="modal-container"
					isOpen={ this.state.modalIsOpen }
					contentLabel="Edit Playlist"
					shouldCloseOnOverlayClick={ true }
					className={{
						base: 'modal',
						afterOpen: 'modal-after-open',
						beforeClose: 'modal-before-close'
					}}
					overlayClassName={{
						base: '',
						afterOpen: '',
						beforeClose: ''
					}}
				>
					<div className="modal-content" data-ta="playlistModal">
						<div className="grid-x">
							<div className="cell">
								{ this.renderMainContent() }
							</div>
						</div>

						
					</div>
					<div className="modal-button-group grid-x text-center">
						<div className="cell large-4"></div>
						<div className="cell large-4">
							<button
								data-ta="closePlaylistModalBtn"
								className="button hollow large"
								onClick={ this.handleCloseModal }
							>
								Cancel
							</button>
							<button
								data-ta="savePlaylistModalBtn"
								className="button hollow large"
								onClick={ this.onClick }
							>
								Save
							</button>
						</div>
						<div className="cell large-4"></div>
					</div>
				</ReactModal>

				<button
					data-ta="addPlaylistBtn"
					className={ buttonClassName }
					onClick={ this.handleOpenModal }>
					<span className={ `fas fa-${icon} margin-0` }></span> { buttonLabel }
				</button>
			</div>
		);
	}

	getField () {
		const { playlistStore: store, formStore } = this.props;
		const playlist = this.getPlaylist();
		const { _id: dataId } = playlist;

		return (props) => {
			const propsObj = { formStore, store };

			if (_.isEmpty(dataId) !== true) {

				Object.assign(propsObj, { dataId });
			}

			return (
				<FieldFactory { ...props } { ...propsObj } />
			);
		}
	}

	renderMainContent () {
		const {
			playlistStore,
			formStore,
			songsStore,
			listType,
			isHFMRadio = false, /* TODO: remove ! */
			isHFMPicks = false, /* TODO: remove! */
		} = this.props;

		const playlist = this.getPlaylist();
		const Field = this.getField();

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell larage-12">
					<h4>{ this.getTitle(listType) }</h4>
				</div>
				<div className="cell small-6" data-ta="playlistTitleInputContainer">
					<Field fieldKey="playlist.title" />
				</div>
				<div className="cell small-6">	</div>

				<div className="cell small-5">					
				<Field
						fieldKey="playlist.listType"
						defaultValue={ listType }
						value={ listType }
						selected={ listType }
					/>
					{/* <EditImage
						imgSrc={ playlist.artwork }
						store={ playlistStore }
						width="383"
						height="254"
						aspectRatio={ 1.5 }
						imgClassName="image medium playlist"
						handleImageCrop={ this.handleImageCrop } /> */}
				</div>

				<div className="cell small-7">
					{/* <Field
						floatLabel
						fieldKey="playlist.isHFMRadio"
						defaultValue={ isHFMRadio }
					/>
					<Field
						floatLabel
						fieldKey="playlist.isHFMPicks"
						defaultValue={ isHFMPicks }
					/> */}
				</div>

				<div className="cell small-12 text-left">
					<SongSelector
						addSong={ this.addSong }
						removeSong={ this.removeSong }
						onDragEnd={ this.reorderPlaylist }
						songList={ songsStore.songs }
						selectedSongs={ songsStore.getSongByID(playlist.songs) || [] } />
				</div>
			</div>
		);
	}

	getPlaylist () {
		const { playlistStore } = this.props;
		const { playlist = playlistStore.data.playlist.toPOJO() } = this.props;

		playlistStore.set({
			key: 'playlist.isHFMRadio',
			value: true
		});

		return playlist;
	}

	getTitle (listType) {
		let s = 'NEW '
		switch(listType) {
			case 'mzdALbumList': 
				s = s + 'ALBUM LIST'
				break;
			case 'mzdArtistList': 
				s = s + 'ARTIST LIST'
				break;
			case 'mzdRadioList': 
				s = s + 'MUZADO RAIDO LIST'
				break;
		}
		return s
	}

	@autobind
	addSong (songID) {
		const { playlistStore } = this.props;
		const { _id } = this.getPlaylist();
		playlistStore.addSongToPlaylist(_id, songID);
	}

	@autobind
	removeSong (songID) {
		const { playlistStore } = this.props;
		const { _id } = this.getPlaylist();
		playlistStore.removeSongFromPlaylist(_id, songID);
	}

	@autobind
	reorderPlaylist (dropResult) {
		const { playlistStore } = this.props;
		const { _id } = this.getPlaylist();
		console.warn(dropResult);
		console.warn(_id);
		playlistStore.reorderPlaylist(dropResult, _id);
	}

	@autobind
	onClick () {
		const { playlistStore } = this.props;
		const playlist = this.getPlaylist();

		if (playlist._id) {

			playlistStore.updatePlaylist(playlist);
			return;
		}

		playlistStore.savePlaylist();
	}

	@autobind
	handleOpenModal () {
		this.setState({
			modalIsOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			modalIsOpen: false
		});
	}

	@autobind
	async handleImageCrop (imgData) {
		const { playlistStore } = this.props;
		const { _id } = this.getPlaylist();

		if (_.isEmpty(_id)) {

			playlistStore.set({
				key: 'imgData',
				value: imgData
			});

			return;
		}

		await playlistStore.savePlaylistArtwork({ _id, imgData }, {
			silent: true
		});
	}
}

export default PlaylistModal;
